import OAuthAuthPage from "./OAuthAuthPage"

const StripeAuthPage = (props) => {
  return <OAuthAuthPage {...props} provider="stripe" />
}

export default StripeAuthPage
